// На телефоне поднимаем окно над экранной клавиатурой (visualViewport): ResponsiveDialog keyboardInset
import { useEffect, useState } from 'react';

export default function useKeyboardInset(enabled) {
  const [inset, setInset] = useState(0);
  useEffect(() => {
    const vv = window.visualViewport;
    if (!enabled || !vv) {
      setInset(0);
      return undefined;
    }
    const update = () => setInset(Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop)));
    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
    };
  }, [enabled]);
  return inset;
}
